export function getSavings(price: string, previousPrice: string): string | null {
  const current = parseFloat(price);
  const previous = parseFloat(previousPrice);
  if (Number.isNaN(current) || Number.isNaN(previous) || previous <= current) return null;
  const diff = previous - current;
  return Number.isInteger(diff) ? String(diff) : diff.toFixed(2);
}
